import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowRight } from 'lucide-react';
const activities = [{
  title: 'Sports',
  image: 'https://cdn.magicpatterns.com/uploads/45ivYJYnfXytuqkLUm5GS5/sports.jpg',
  description: 'Cricket, Football, Basketball, Athletics'
}, {
  title: 'Debate & Public Speaking',
  image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800&q=80',
  description: 'National and International Competitions'
}, {
  title: 'Arts & Crafts',
  image: 'https://cdn.magicpatterns.com/uploads/ngH7LEgPLrrzVZFWcDNvS9/Arts__Crafts.jpg',
  description: 'Painting, Drawing, Sculpture'
}, {
  title: 'Cultural Activities',
  image: 'https://cdn.magicpatterns.com/uploads/3FqCJtMAySQ3xhsT1X422L/Cultural_Activities.jpg',
  description: 'Music, Dance, Drama, Poetry'
}, {
  title: 'Science Club',
  image: 'https://cdn.magicpatterns.com/uploads/vuRyqG2JykMhF1SXVMvcSv/Science_Club.jpg',
  description: 'Experiments, Projects, Innovation'
}, {
  title: 'Foreign Study Tour',
  image: 'https://cdn.magicpatterns.com/uploads/tJNvnJD7JjBB48ZfSiqSah/Foreign_Study_Tour.jpg',
  description: 'Educational Trips, Cultural Exchange, Global Exposure'
}];
export function ExtraCurricular() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="departments" className="py-20 bg-white" data-id="element-73">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="text-center mb-16" data-id="element-75">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-76">
            Extra-Curricular Activities
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-77"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-78">
            Developing well-rounded individuals through diverse activities
          </p>
        </div>

        <div ref={ref} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-79">
          {activities.map((activity, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative group overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all h-64" data-id="element-80">
              <img src={activity.image} alt={activity.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-81" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" data-id="element-82" />
              <div className="absolute inset-0 flex flex-col justify-end p-6 text-white" data-id="element-83">
                <h3 className="text-2xl font-heading font-bold mb-2 transform group-hover:-translate-y-2 transition-transform" data-id="element-84">
                  {activity.title}
                </h3>
                <p className="text-white/90 text-sm transform translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all" data-id="element-85">
                  {activity.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="text-center mt-12" data-id="element-86">
          <a href="#" className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg font-semibold transition-colors" data-id="element-87">
            All Activities
            <ArrowRight size={18} data-id="element-88" />
          </a>
        </motion.div>
      </div>
    </section>;
}